import { useTranslation } from 'libs/i18n';
import { usePageTitle } from 'libs/navigation';

import { useLogin } from '../hooks';
import { LoginView } from '../views/LoginView/LoginView';

export const LoginContainer = () => {
  const {
    formError,
    onSubmit,
    loading,
    isOpenVerificationDialog,
    verificationFormError,
    onSubmitVerification,
    onCloseVerificationDialog,
  } = useLogin();

  const { t } = useTranslation();

  usePageTitle(t('auth.login.pageTitle'));

  return (
    <LoginView
      formError={formError}
      isOpenVerificationDialog={isOpenVerificationDialog}
      loading={loading}
      verificationFormError={verificationFormError}
      onCloseVerificationDialog={onCloseVerificationDialog}
      onSubmit={onSubmit}
      onSubmitVerification={onSubmitVerification}
    />
  );
};
